<template>
  <transition name="fade">
    <div class="alert mb-0" :class="'alert-' + alert.type" v-if="alert.isVisible">{{ alert.message }}</div>
  </transition>
</template>

<script setup>
import useFlashMessage from '../composables/useFlashMessage';

const { alert, onClose } = useFlashMessage();
</script>

<style scoped>
.alert {
  position: fixed;
  left: 32px;
  bottom: 32px;
  z-index: 100000;
}

.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
